<template>
  <div class="deposit-signature-section">
    <SidebarAccordion title="Acompte &amp; signature" :default-open="isQuoteInCreation" v-bind="$attrs">
      <template #summary>
        <span v-if="depositSummary">{{ depositSummary }}</span>
      </template>

      <div class="deposit-fields-row">
        <CustomTextField class="deposit" :content="depositInput" />
        <CustomTextField class="depositPercent" :content="depositPercentInput" />
      </div>

      <div class="signature-field-wrap">
        <CustomSwitchField class="signature" :content="signatureInput" />
      </div>

      <div class="document-editor-button full-width secondary-action" v-if="business && business.signature && business.signature.signedAt">
        <CustomButton class="show-signature" @click="openSignatureModal()" :is-secondary="true" :isCompact="true" :params="buttons.showSignature" />
      </div>
    </SidebarAccordion>
  </div>
  <SignatureBusinessModal ref="signatureBusinessModal" />
</template>

<script>
import CustomTextField from "@/components/forms/customs/customTextField/CustomTextField.vue";
import CustomSwitchField from "@/components/forms/customs/customSwitchField/CustomSwitchField.vue";
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import SignatureBusinessModal from "@/components/modals/SignatureBusinessModal.vue";
import SidebarAccordion from "@/components/businessEdition/SidebarAccordion.vue";
import {isEditableBusiness, roundDownTo2Decimals} from "@/utils";
import {BUSINESS_STATUS_ENUM} from "@/models/businessStatusEnum";

export default {
  name: 'DepositSignatureSection',
  components: {SignatureBusinessModal, CustomTextField, CustomSwitchField, CustomButton, SidebarAccordion},
  // Les attributs non déclarés (open, toggle-callback...) sont transmis à l'accordéon pour pouvoir piloter son état depuis le parent
  inheritAttrs: false,
  props: {
    business: {type: Object, default: undefined},
    depositInput: {type: Object, required: true},
    depositPercentInput: {type: Object, required: true},
    signatureInput: {type: Object, required: true},
    totals: {type: Object, required: true},
    readOnly: {type: Boolean, default: false},
  },
  computed: {
    // Section ouverte uniquement tant que le devis est en création, fermée sinon
    isQuoteInCreation() {
      return !!this.business && !this.business.invoiceNumber && this.business.status === BUSINESS_STATUS_ENUM.CREATION.value;
    },
    // Montant de l'acompte affiché à côté du titre quand la section est repliée
    depositSummary() {
      const deposit = Number(this.depositInput.value);
      return deposit ? deposit.toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' €' : '';
    },
  },
  watch:{
    "selfTotals": {
      deep: true,
      handler() {
        this.isDepositWatchDeactivatedOnceTime = true;
        this.selfDepositInput.value = roundDownTo2Decimals(this.selfTotals.ttcAmount * this.depositPercentInput.value / 100);
      }
    },
    "selfDepositInput.value": {
      handler(value) {
        if(isEditableBusiness(this.business)) {
          if (value) {
            this.selfSignatureInput.value = true;
            this.selfSignatureInput.readOnly = true;
          } else {
            this.selfSignatureInput.readOnly = false;
          }
        }
        if (this.readOnly) this.selfSignatureInput.readOnly = true;

        if(this.isDepositWatchDeactivatedOnceTime){
          this.isDepositWatchDeactivatedOnceTime = false;
          return;
        }
        this.isDepositPercentWatchDeactivatedOnceTime = true;
        this.selfDepositPercentInput.value = roundDownTo2Decimals(value * 100 / this.totals.ttcAmount);
      }
    },
    "selfDepositPercentInput.value": {
      handler(value) {
        if(this.isDepositPercentWatchDeactivatedOnceTime){
          this.isDepositPercentWatchDeactivatedOnceTime = false;
          return;
        }
        this.isDepositWatchDeactivatedOnceTime = true;
        this.selfDepositInput.value = roundDownTo2Decimals(this.totals.ttcAmount * value / 100);
      }
    }
  },
  data() {
    return {
      buttons:{
        showSignature: {text: "Afficher la signature"}
      },
      selfDepositInput: this.depositInput,
      selfDepositPercentInput: this.depositPercentInput,
      selfSignatureInput: this.signatureInput,
      selfTotals: this.totals,
      isDepositWatchDeactivatedOnceTime: false
    }
  },
  mounted() {
    this.selfSignatureInput.value = !!this.business.signature;
    this.selfDepositInput.value = this.business.deposit;
    if('deposit' in this.business){
      this.selfSignatureInput.value = true;
      this.selfSignatureInput.readOnly = true;
    }else{
      this.selfSignatureInput.readOnly = false;
    }
    if (this.readOnly) this.selfSignatureInput.readOnly = true;
  },
  methods: {
    openSignatureModal(){
      this.$refs.signatureBusinessModal.openModal(this.business);
    },
  }
};
</script>

<style lang="stylus" scoped>
.deposit-fields-row
  display flex
  gap 18px
  .deposit
    flex 1 1 auto
    width auto !important
  .depositPercent
    flex 0 0 80px

.signature-field-wrap
  margin-top 10px
  margin-bottom 10px
  .signature
    width 100% !important

</style>